import React from 'react';

const FoundationSection = ({ title, children, id, imageSrc, imageAlt, imagePosition = 'right' }) => {
  return (
    <section id={id} className="py-16 md:py-24 px-4 md:px-8 bg-gray-50 text-gray-800 relative overflow-hidden">
      <img
        src="src=/img8.jpg"
        alt="Patrón cultural afrocolombiano"
        className="absolute inset-0 w-full h-full object-cover opacity-10"
      />
      <div className="relative z-10 max-w-6xl mx-auto">
        <h2 className="text-3xl md:text-5xl font-bold text-center mb-12 text-green-800">
          {title}
        </h2>
        <div className={`bg-white p-6 md:p-10 rounded-3xl shadow-2xl border border-gray-200 flex flex-col ${imageSrc ? 'md:flex-row' : ''} ${imagePosition === 'left' ? 'md:flex-row-reverse' : ''} items-center gap-8`}>
          {imageSrc && (
            <div className="md:w-1/2 flex justify-center">
              <img
                src={imageSrc}
                alt={imageAlt}
                className="rounded-2xl shadow-lg w-full h-auto max-w-md md:max-w-full object-cover"
              />
            </div>
          )}
          <div className={`${imageSrc ? 'md:w-1/2' : 'w-full'}`}>
            {children}
          </div>
        </div>
      </div>
    </section>
  );
};

export default FoundationSection;